// MARK://dhk8/pos/lib/queries/catalog
// Query tipada del menú activo — F4.4 / ADR-0009. El POS lee el menú por el grafo
// (catalog-menus, tenant del JWT) — misma query base que Admin (menus). Los productos
// del menú se resuelven por federación (MenuProduct.product → erp-products) para
// nombre/precio. Escrituras (menús/secciones) siguen REST. Campos inline.
import { graphql } from '../../gql/index.js'

// F9.3 / ADR-0008: el menú activo se sirve por UNA query de composición de la
// vertical (nintaigo-graph → `menuScreen`). En una sola llamada la federación
// arma menú → secciones → MenuProduct → product (erp-products: nombre/precio/imagen)
// + product.availability (erp-inventory: canMake/tracked). Esto reemplaza el par
// previo (PosActiveMenu por el grafo + enrichWithStock por REST a erp-inventory):
// imagen + dato + inventario llegan juntos en la misma respuesta.
export const PosMenuScreenQuery = graphql(`
  query PosMenuScreen($id: ID!) {
    menuScreen(id: $id) {
      id
      name
      active
      sections {
        id
        name
        ordinal
        active
        products {
          productId
          ordinal
          visible
          overridePriceCents
          product {
            id
            name
            sku
            priceCents
            description
            imageUrl
            availability { canMake tracked }
          }
        }
      }
    }
  }
`);

export const PosActiveMenuQuery = graphql(`
  query PosActiveMenu($limit: Int) {
    menus(limit: $limit) {
      items {
        id
        name
        active
        sections {
          id
          name
          ordinal
          active
          products {
            productId
            ordinal
            visible
            overridePriceCents
            product { id name sku priceCents description imageUrl }
          }
        }
      }
    }
  }
`);

// 86 / agotar producto: el cajero apaga (o vuelve a encender) la disponibilidad
// de un producto en servicio sin salir del POS. `setProductAvailability` togglea
// `Product.active` en erp-products (tenant del JWT, IDOR-guard por tenant). El
// menú activo (menuScreen / menus) se invalida tras la mutación para refrescar
// el badge "Agotado". Doc nuevo → codegen necesario para PosSetProductAvailabilityMutation.
export const PosSetProductAvailabilityMutation = graphql(`
  mutation PosSetProductAvailability($id: ID!, $available: Boolean!) {
    setProductAvailability(id: $id, available: $available) {
      id
      active
    }
  }
`);
